export const TextErrors = (errors, touched) => {
  let message = "";
  const intersect = Object.keys(touched).filter(value =>
    Object.keys(errors).includes(value)
  );
  if (intersect.length === 1) message = errors[intersect[0]];
  else if (intersect.length > 1) message = "مقادیر وارد شده اشتباه است.";

  return message ? (
    <div className="input-feedback">
      <div className="error-dot ml-2" />
      {message}
    </div>
  ) : (
    <></>
  );
};
